import HallUI from "../HallUI";
import {Global} from "../../Shared/Global";
import ActivityData from "./ActivityData";
import PopWindowManager from "../../Shared/PopWindowManager";
import ImageCache from "../../Shared/ImageCache";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RecommendActivity extends cc.Component {

    @property(cc.Sprite)
    bgNode: cc.Sprite = null;
    @property(cc.Widget)
    xWidget :cc.Widget = null;

    onLoad() {
        this.bgNode.node.active = false
    }

    async start() {
        let popData = this.node["popData"];
        let textureUrl = popData.activityImg;

        ImageCache.loadImage(textureUrl,function (err,texture) {
            if (cc.isValid(this.bgNode)){
                this.bgNode.node.getChildByName("logo").active = false;
                this.bgNode.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                this.bgNode.node.active = true;
                this.xWidget.updateAlignment();
            }
        }.bind(this))
        // 一段时间网图还没加载出来，就显示默认图
        this.scheduleOnce(function () {
            this.bgNode.node.active = true
        }.bind(this), 0.2)

    }

    onBtnClose(){
        AudioManager.playSound("close");
        PopWindowManager.openNext();
        this.node.destroy();
    }

    onBtnGo(event,param){
        cc.log("====popData:",this.node["popData"]);
        let hallUI : HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
        let pfbActivity =  hallUI.openChildUI(hallUI.pfbActivity, false);
        pfbActivity.getComponent("ActivityAndTask").updateUI("huodong",this.node["popData"]);
        this.node.destroy();
    }

}
